var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#4659CA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_1271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9313 20.5387H32.6967V21.8205H31.4618V20.5387H30.2274V19.2572H31.4618V17.9756H32.6967V19.2572H33.9313V20.5387ZM29.4263 20.5387H28.1919V21.8205H26.9573V20.5387H25.7227V19.2572H26.9573V17.9756H28.1919V19.2572H29.4263V20.5387Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.252 22.642C22.3315 24.3365 20.5825 25.4816 18.5752 25.4816C16.5801 25.4816 14.841 24.3508 13.9159 22.6743C13.4512 21.833 13.2071 20.88 13.2081 19.9102C13.2081 16.8333 15.6111 14.3389 18.5752 14.3389C20.5574 14.3389 22.2873 15.4556 23.217 17.115L27.9082 14.3108C26.0436 10.9696 22.5624 8.72168 18.5752 8.72168C12.6224 8.72168 7.79688 13.731 7.79688 19.9102C7.79688 21.9374 8.31639 23.8384 9.22437 25.4782C11.0843 28.8371 14.5754 31.0988 18.5752 31.0988C22.5823 31.0988 26.0789 28.828 27.9361 25.4592L23.252 22.642Z",
    fill: "#F8FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_1271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    fill: "white",
    transform: "translate(7 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpp);
export default __webpack_public_path__ + "static/media/cpp.bc0941f95a1a9ce0ff7a14ed909d34bb.svg";
export { ForwardRef as ReactComponent };